import { Marker } from "react-leaflet";
import BaseMap from "./BaseMap";
import { mapPinIcon } from "./map-pin";

export default function StaticMap({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) {
  const safeLat = typeof latitude === "number" && !isNaN(latitude) ? latitude : 0;
  const safeLng = typeof longitude === "number" && !isNaN(longitude) ? longitude : 0;

  return (
    <BaseMap
      latitude={safeLat}
      longitude={safeLng}
      zoom={16}
    >
      <Marker position={[safeLat, safeLng]} icon={mapPinIcon} />
    </BaseMap>
  );
}
